import { render, staticRenderFns } from "./FURminatorNews.vue?vue&type=template&id=0df666be&scoped=true"
import script from "./FURminatorNews.vue?vue&type=script&lang=js"
export * from "./FURminatorNews.vue?vue&type=script&lang=js"
import style0 from "./FURminatorNews.vue?vue&type=style&index=0&id=0df666be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df666be",
  null
  
)

export default component.exports